import React from "react";
import _, { flatten, isString, map } from "lodash";
import { Button, Form, Row, Col, Typography , Alert, AutoComplete} from "antd";
import { DeleteIcon } from 'components/Icons';
import GlobalSettingAPI from "restAPI/GlobalSettingAPI";
import { preventEnter } from "./TagTable";
import { DEFAULT_TAGS_FILTER_MESSAGE } from "constants/FilterConstants";

class ColumnFilterKeyValue extends React.Component {
    static filterLabelFormatter = (tag) => tag.value ? `${tag.key}/${tag.value}` : tag.key
    inputRef = React.createRef()
    formRef = React.createRef()
    constructor(props) {
        super(props);
        this.state = {
            tags: [],
            changed: false,
            tagOptions: [{
              key: [],
              value: [],
            }],
            selectedTags: [],
        }
        _.bindAll(
            this,
            "applyFilter",
            "clearFilter",
            "onFormChange",
            "getTagKeyOptions",
            "onKeyChange",
        )
    }
    focusInput() {
        if (this.inputRef.current) {
          this.focusTimeOut = setTimeout(() => {
            this.inputRef.current.select();
          }, 300);
        }
    }
    componentWillUnmount() {
        if (!_.isUndefined(this.focusTimeOut)) {
          clearTimeout(this.focusTimeOut);
        }
    }
    getSearchText() {
        const { selectedKeys } = this.props;

        const tags = _.isEmpty(selectedKeys) ? [{key: "", value: ""}] : selectedKeys;
      this.updateTags(tags);
    }
  updateTags(tags) {
    this.formRef.current.setFieldsValue({
      tags
    })
    this.setState({
      tags,
      changed: false,
    }, this.focusInput);
    }

    getTagKeyOptions(){
      const { promise, cancel } = GlobalSettingAPI.getTagsLibrary();
      promise.then((res) => {
        const tagArray = _.map(res.library, (item) => {
          const [key, value] = item.split(":");
          const valueArray = value?.split(",").map((v) => v.trim()) || [];
          return { key, value: valueArray };
        });
        this.setState({
          tagOptions: tagArray
        })
      })
      return cancel;
    }

    componentDidMount() {
        this.getSearchText();
        this.getTagKeyOptions();
    }
    componentDidUpdate(prevProps) {
        const { visible } = this.props;
        if (prevProps.visible !== visible) {
            if (visible) {
                this.getSearchText();
            } else {
                this.setState({ error: false });
            }
        }
    }
    async applyFilter() {
        try {
            await this.formRef.current.validateFields();
        } catch (e) {
            this.setState({ error: true });
            return;
        }
        const tags = this.formRef.current.getFieldsValue().tags;
        const { confirm, setSelectedKeys } = this.props;
        let filteredTags = _.filter(tags, tag => !_.isEmpty(_.trim(tag.key)));
        filteredTags = _.map(filteredTags, (tag) => !tag.value ? _.omit(tag, ['value']) : tag);
        setSelectedKeys(filteredTags);
        confirm();
    }
    onFormChange() {
        this.setState({ error: false, changed: true, });
    }
    clearFilter() {
        const { clearFilters } = this.props;
        clearFilters();
        this.updateTags([{}]);
    }
    onKeyChange(value, index) {
      const { selectedTags } = this.state;
      const newTags = [...selectedTags];
      newTags[index] = value;
      this.setState({ selectedTags: newTags });
    }
    render() {
        const { error, tagOptions, selectedTags } = this.state;
        const { hideInfo, tagsMessage } = this.props;
        const tagKeys = tagOptions.map((item) => item.key);
        const getTagValues = (index) => flatten(
          tagOptions
            .filter(
              (record) => record.key === selectedTags?.[index]
            )
            .map((record) => record.value)
        );
        return (
          <div className="column-filter" style={{ width: 332 }}>
            <div className="p-xs">
              <Form ref={this.formRef} onValuesChange={this.onFormChange}>
                <Form.List name="tags">
                  {(fields, { add, remove }) => (
                    <>
                      <Row>
                        <Col className="m-b-xs">
                          {hideInfo ? null : (
                            <Alert
                              type="info"
                              description={tagsMessage || DEFAULT_TAGS_FILTER_MESSAGE} 
                            />
                          )}
                        </Col>
                        <Col span={12} className="text-bold">
                          Key/Tag
                        </Col>
                        <Col span={12} className="text-bold">
                          Value
                        </Col>
                      </Row>
                      {_.map(fields, (field, index) => (
                        <Row gutter={[10, 10]}>
                          <Col span={11}>
                            <Form.Item
                              noStyle
                              {...field}
                              name={[field.name, "key"]}
                              rules={[
                                { required: true, message: "Key is required" },
                              ]}
                            >
                              <AutoComplete  
                                filterOption={filterOption}
                                style={{ width: 135 }} 
                                onKeyPress={preventEnter}
                                autoFocus
                                onChange={(value) => this.onKeyChange(value, index)}
                              >
                              {_.map(tagKeys, (option, index) => {
                                return (
                                  <AutoComplete.Option
                                    key={index}
                                    value={option}
                                  >
                                    {option}
                                  </AutoComplete.Option>
                                );
                              })}
                              </AutoComplete>
                            </Form.Item>
                          </Col>
                          <Col span={11}>
                            <Form.Item
                              noStyle
                              {...field}
                              name={[field.name, "value"]}
                            >
                              <AutoComplete 
                                filterOption={filterOption}
                                style={{ width: 135 }} 
                                onKeyPress={preventEnter}
                              >
                                {map(getTagValues(index), (option, index) => {
                                  return (
                                    <AutoComplete.Option
                                      key={index}
                                      value={option}
                                    >
                                      {option}
                                    </AutoComplete.Option>
                                  );
                                })}
                              </AutoComplete>
                            </Form.Item>
                          </Col>
                          <Col span={2}>
                            <Button
                              disabled={fields.length === 1}
                              onClick={() => remove(field.name)}
                              type="text"
                              className="p-x-0"
                              danger
                            >
                              <DeleteIcon />
                            </Button>
                          </Col>
                        </Row>
                      ))}
                      <Row>
                        <Col span={16}>
                          {error ? (
                            <Typography.Text type="danger">
                              Key/Tag field should not be empty
                            </Typography.Text>
                          ) : null}
                        </Col>
                        <Col span={4} className="text-right">
                          <Button disabled={(this.props?.limit)&&fields?.length>=this.props?.limit} size="small" onClick={() => add()}>
                            Add more
                          </Button>
                        </Col>
                      </Row>
                    </>
                  )}
                </Form.List>
              </Form>
            </div>
            <div className="ant-table-filter-dropdown-btns">
              <Button size="small" type="link" onClick={this.clearFilter}>
                Clear
              </Button>
              <Button type="primary" size="small" onClick={this.applyFilter} disabled={!this.state.changed}>
                Apply
              </Button>
            </div>
          </div>
        );
    }
}

export default ColumnFilterKeyValue;

export const filterOption = (inputValue, option) =>
  isString(option.value) &&
  option.value?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
